<template>
<div class="messages-playground" :class="{ 'smooth-scroll-enabled': smoothScrollEnabled }">
    <ul ref="messagesList" :class="{ 'smooth-scroll': smoothScrollEnabled }">
        <li v-for="(message, index) in messages" 
            :key="index" 
            :class="{ 
                'active': index === messages.length - 1, 
                'smooth-entry': smoothScrollEnabled,
                'message-item': true,
                'speaker-message': diarizationEnabled && getSpeakerInfo(message).hasSpeaker,
                [`speaker-${getSpeakerInfo(message).speakerNumber}`]: diarizationEnabled && getSpeakerInfo(message).hasSpeaker && getSpeakerInfo(message).speakerNumber > 0
            }"
        >
            <span class="message-text" :class="{ 'highlighted': diarizationEnabled && getSpeakerInfo(message).speakerNumber > 0 }">
                {{ getSpeakerInfo(message).messageText }}
            </span>
        </li>
        <li v-if="showLoading && isListening" class="loading-item active">
            <span class="loading">
                <span class="dot">.</span><span class="dot">.</span><span class="dot">.</span>
            </span>
        </li>
        <li v-if="!isListening && messages.length === 0" class="transcription-placeholder active">
            <div class="placeholder-content">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="mb-2 text-slate-400 fill-current">
                    <path fill="currentColor" d="M5 15.0625C4.77604 15.0625 4.58594 14.9844 4.42969 14.8281C4.27865 14.6719 4.20312 14.4818 4.20312 14.2578V10.4609C4.20312 10.237 4.27865 10.0469 4.42969 9.89062C4.58594 9.72917 4.77604 9.64844 5 9.64844C5.22396 9.64844 5.41406 9.72917 5.57031 9.89062C5.73177 10.0469 5.8125 10.237 5.8125 10.4609V14.2578C5.8125 14.4818 5.73177 14.6719 5.57031 14.8281C5.41406 14.9844 5.22396 15.0625 5 15.0625ZM7.79688 18.1328C7.57292 18.1328 7.38281 18.0547 7.22656 17.8984C7.07552 17.7422 7 17.5521 7 17.3281V7.39062C7 7.16146 7.07552 6.96875 7.22656 6.8125C7.38281 6.65625 7.57292 6.57812 7.79688 6.57812C8.02604 6.57812 8.21875 6.65625 8.375 6.8125C8.53125 6.96875 8.60938 7.16146 8.60938 7.39062V17.3281C8.60938 17.5521 8.53125 17.7422 8.375 17.8984C8.21875 18.0547 8.02604 18.1328 7.79688 18.1328ZM10.5938 20.9766C10.3698 20.9766 10.1797 20.8984 10.0234 20.7422C9.8724 20.5859 9.79688 20.3958 9.79688 20.1719V4.54688C9.79688 4.32292 9.8724 4.13281 10.0234 3.97656C10.1797 3.82031 10.3698 3.74219 10.5938 3.74219C10.8229 3.74219 11.0156 3.82031 11.1719 3.97656C11.3281 4.13281 11.4062 4.32292 11.4062 4.54688V20.1719C11.4062 20.3958 11.3281 20.5859 11.1719 20.7422C11.0156 20.8984 10.8229 20.9766 10.5938 20.9766ZM13.3906 17.0156C13.1667 17.0156 12.9766 16.9375 12.8203 16.7812C12.6693 16.625 12.5938 16.4349 12.5938 16.2109V8.50781C12.5938 8.28385 12.6693 8.09375 12.8203 7.9375C12.9766 7.77604 13.1667 7.69531 13.3906 7.69531C13.6146 7.69531 13.8047 7.77604 13.9609 7.9375C14.1224 8.09375 14.2031 8.28385 14.2031 8.50781V16.2109C14.2031 16.4349 14.1224 16.625 13.9609 16.7812C13.8047 16.9375 13.6146 17.0156 13.3906 17.0156ZM16.1953 19.2734C15.9661 19.2734 15.7734 19.1953 15.6172 19.0391C15.4661 18.8828 15.3906 18.6927 15.3906 18.4688V6.25C15.3906 6.02604 15.4661 5.83594 15.6172 5.67969C15.7734 5.52344 15.9661 5.44531 16.1953 5.44531C16.4193 5.44531 16.6094 5.52344 16.7656 5.67969C16.9219 5.83594 17 6.02604 17 6.25V18.4688C17 18.6927 16.9219 18.8828 16.7656 19.0391C16.6094 19.1953 16.4193 19.2734 16.1953 19.2734ZM18.9844 15.5703C18.7604 15.5703 18.5703 15.4922 18.4141 15.3359C18.263 15.1797 18.1875 14.9922 18.1875 14.7734V9.94531C18.1875 9.72656 18.263 9.53906 18.4141 9.38281C18.5703 9.22135 18.7604 9.14062 18.9844 9.14062C19.2135 9.14062 19.4062 9.22135 19.5625 9.38281C19.7188 9.53906 19.7969 9.72656 19.7969 9.94531V14.7734C19.7969 14.9922 19.7188 15.1797 19.5625 15.3359C19.4062 15.4922 19.2135 15.5703 18.9844 15.5703Z"></path>
                </svg>
                <div>{{ $t('transcriptionPlaceholder') }}</div>
            </div>
        </li>
    </ul>
</div>
</template>

    
<script>
export default {
    name: 'MessagesListPlayground',
    props: {
        isListening: Boolean,
        messages: {
            type: Array,
            required: true
        },
        smoothScrollEnabled: {
            type: Boolean,
            default: true
        },
        diarizationEnabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showLoading: true,
        };
    },
    computed: {
        shouldShowLoading() {
            return this.messages.length === 0;
        }
    },
    watch: {
        messages: {
            immediate: true,
            handler(messages, oldMessages) {
                if (messages.length > 0) {
                    this.showLoading = false;
                    
                    if (oldMessages && messages.length > oldMessages.length) {
                        const delay = this.smoothScrollEnabled ? 150 : 50;
                        setTimeout(() => {
                            this.scrollToLatest();
                        }, delay);
                    }
                } else {
                    this.showLoading = true;
                }
            }
        },
        shouldShowLoading(newValue) {
            this.showLoading = newValue;
        },
        smoothScrollEnabled() {
            this.$nextTick(() => {
                if (this.messages.length > 0) {
                    this.scrollToLatest();
                }
            });
        }
    },
    methods: {
        getSpeakerInfo(message) {
            // Parse message format: "[Speaker X]: message content"
            const speakerRegex = /^\[Speaker (\d+)\]:\s*(.*)$/
            const match = message.match(speakerRegex)
            
            if (match) {
                const speakerNumber = parseInt(match[1])
                return {
                    hasSpeaker: true,
                    speakerNumber: speakerNumber,
                    speakerLabel: `Speaker ${speakerNumber}`,
                    messageText: match[2]
                }
            }
            
            // No speaker information, treat as Speaker 0 (original style)
            return {
                hasSpeaker: false,
                speakerNumber: 0,
                speakerLabel: null,
                messageText: message
            }
        },
        
        scrollToLatest() {
            if (this.$refs.messagesList) {
                const container = this.$refs.messagesList.parentElement;
                
                if (this.smoothScrollEnabled) {
                    // Enhanced smooth scrolling with custom animation
                    this.smoothScrollTo(container, container.scrollHeight, 500);
                } else {
                    container.scrollTop = container.scrollHeight;
                }
            }
        },
        
        smoothScrollTo(element, target, duration) {
            if (!element || !('scrollTop' in element)) return;

            const maxScroll = element.scrollHeight - element.clientHeight;
            target = Math.max(0, Math.min(target, maxScroll));

            const start = element.scrollTop;
            const change = target - start;
            const startTime = performance.now();

            const easeInOutCubic = (t) => t < 0.5 
                ? 4 * t * t * t 
                : 1 - Math.pow(-2 * t + 2, 3) / 2;

            const animateScroll = (currentTime) => {
                const elapsed = currentTime - startTime;
                const progress = Math.min(elapsed / duration, 1);
                const easedProgress = easeInOutCubic(progress);

                element.scrollTop = Math.round(start + change * easedProgress);

                if (progress < 1) {
                    requestAnimationFrame(animateScroll);
                } else {
                    element.scrollTop = target;
                }
            };

            requestAnimationFrame(animateScroll);
        }
    },
    mounted() {
        if (this.messages.length > 0) {
            this.showLoading = false;
            
            // Initial scroll to bottom if there are messages
            this.$nextTick(() => {
                this.scrollToLatest();
            });
        }
    }
};
</script>

    
<style scoped>
.messages-playground {
    background-color: var(--container-color);
    width: 100%;
    height: 550px;
    overflow-y: auto;
    text-align: center;
    border-radius: 8px;
    position: relative;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 16px;
    transition: margin-top 0.2s linear, transform 0.2s linear;
    -webkit-overflow-scrolling: touch; /* Smoother scrolling on iOS */
}

.messages-playground ul {
    list-style: none;
    padding: 0;
    margin: 32px 0 0 0;
    width: 100%;
    flex: 1;
}

/* We're using custom scroll animation with enhanced smooth scrolling */
.messages-playground ul.smooth-scroll {
    position: relative;
    overflow-anchor: auto;
    scroll-behavior: auto; /* We handle smooth scrolling manually */
}

/* Enhanced smooth scrolling container */
.messages-playground.smooth-scroll-enabled {
    scroll-behavior: auto; /* Disable default to use custom */
}

.messages-playground li {
    font-size: 28px;
    font-family: 'Montserrat', sans-serif;
    color: var(--text-color);
    transition: filter 0.2s linear, opacity 0.2s linear, transform 0.2s linear;
    word-wrap: break-word;
    transform-origin: center bottom;
    will-change: transform, opacity;
}

.messages-playground li.smooth-entry {
    animation: slideInUp 1.5s cubic-bezier(0.05, 0.82, 0.17, 1);
}

/* Enhanced animation for smooth scroll mode */
.messages-playground.smooth-scroll-enabled li.smooth-entry {
    animation: slideInUpSmooth 2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

@keyframes slideInUp {
    0% {
        opacity: 0;
        transform: translateY(8px) scale(0.95);
    }
    40% {
        opacity: 0.4;
    }
    80% {
        opacity: 0.8;
    }
    100% {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

@keyframes slideInUpSmooth {
    0% {
        opacity: 0;
        transform: translateY(20px) scale(0.9);
    }
    100% {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

/* Special animation for speaker messages */
.speaker-message.smooth-entry {
    animation: slideInUpSpeaker 2.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

@keyframes slideInUpSpeaker {
    0% {
        opacity: 0;
        transform: translateY(25px) scale(0.85);
    }
    15% {
        opacity: 0.1;
        transform: translateY(20px) scale(0.88);
    }
    40% {
        opacity: 0.4;
        transform: translateY(12px) scale(0.94);
    }
    70% {
        opacity: 0.8;
        transform: translateY(4px) scale(0.98);
    }
    85% {
        opacity: 0.95;
        transform: translateY(1px) scale(1.01);
    }
    100% {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

@media screen and (max-width: 768px) {
    .messages-playground {
        width: 100%;
        height: 400px;
        box-sizing: border-box;
    }
    
    .message-text.highlighted {
        padding: 3px 6px;
        font-size: 24px;
    }
    
    .messages-playground li {
        font-size: 24px;
    }
    
    .messages-playground li:not(.active) {
        font-size: 20px;
    }
}

@media screen and (max-height: 600px) {
    .messages-playground {
        width: 100%;
        height: 380px;
        box-sizing: border-box;
    }
}

@media screen and (max-height: 700px) {
    .messages-playground {
        width: 100%;
        height: 500px;
        box-sizing: border-box;
    }
}

.messages-playground li:not(.active) {
    font-size: 22px;
    padding: 2px;
    opacity: 0.6;
}

.messages-playground li.active {
    font-weight: bold;
    filter: none;
    opacity: 1;
    padding-top: 16px;
    padding-bottom: 12px;
}

/* Speaker-specific styling */
.speaker-message {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
}

.message-text {
    display: block;
}

.message-text.highlighted {
    padding: 4px 8px;
    border-radius: 8px;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05));
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transition: all 0.3s linear;
    position: relative;
}

.message-text.highlighted:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

/* Speaker 1 - Blue theme */
.speaker-1 .message-text.highlighted {
    background: linear-gradient(135deg, rgba(59, 130, 246, 0.15), rgba(59, 130, 246, 0.08));
    border-color: rgba(59, 130, 246, 0.3);
    color: var(--text-color);
}

/* Speaker 2 - Green theme */
.speaker-2 .message-text.highlighted {
    background: linear-gradient(135deg, rgba(34, 197, 94, 0.15), rgba(34, 197, 94, 0.08));
    border-color: rgba(34, 197, 94, 0.3);
    color: var(--text-color);
}

/* Speaker 3 - Purple theme */
.speaker-3 .message-text.highlighted {
    background: linear-gradient(135deg, rgba(168, 85, 247, 0.15), rgba(168, 85, 247, 0.08));
    border-color: rgba(168, 85, 247, 0.3);
    color: var(--text-color);
}

/* Speaker 4 - Orange theme */
.speaker-4 .message-text.highlighted {
    background: linear-gradient(135deg, rgba(249, 115, 22, 0.15), rgba(249, 115, 22, 0.08));
    border-color: rgba(249, 115, 22, 0.3);
    color: var(--text-color);
}

/* Speaker 5 - Pink theme */
.speaker-5 .message-text.highlighted {
    background: linear-gradient(135deg, rgba(236, 72, 153, 0.15), rgba(236, 72, 153, 0.08));
    border-color: rgba(236, 72, 153, 0.3);
    color: var(--text-color);
}

/* Speaker 6 - Teal theme */
.speaker-6 .message-text.highlighted {
    background: linear-gradient(135deg, rgba(20, 184, 166, 0.15), rgba(20, 184, 166, 0.08));
    border-color: rgba(20, 184, 166, 0.3);
    color: var(--text-color);
}

/* Speaker 7 - Red theme */
.speaker-7 .message-text.highlighted {
    background: linear-gradient(135deg, rgba(239, 68, 68, 0.15), rgba(239, 68, 68, 0.08));
    border-color: rgba(239, 68, 68, 0.3);
    color: var(--text-color);
}

/* Speaker 8 - Indigo theme */
.speaker-8 .message-text.highlighted {
    background: linear-gradient(135deg, rgba(99, 102, 241, 0.15), rgba(99, 102, 241, 0.08));
    border-color: rgba(99, 102, 241, 0.3);
    color: var(--text-color);
}

/* Dark mode adjustments */
@media (prefers-color-scheme: dark) {
    .message-text.highlighted {
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.02));
        border-color: rgba(255, 255, 255, 0.1);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    }
    
    .message-text.highlighted:hover {
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
    }
}

/* Fallback for speakers beyond 8 - cycle through colors */
.speaker-9 .message-text.highlighted { background: linear-gradient(135deg, rgba(59, 130, 246, 0.15), rgba(59, 130, 246, 0.08)); border-color: rgba(59, 130, 246, 0.3); }

.speaker-10 .message-text.highlighted { background: linear-gradient(135deg, rgba(34, 197, 94, 0.15), rgba(34, 197, 94, 0.08)); border-color: rgba(34, 197, 94, 0.3); }

.loading-item {
    padding: 12px;
}

.loading {
    font-size: 24px;
    font-family: 'Montserrat', sans-serif;
    color: var(--text-color);
    display: flex;
    justify-content: center;
    gap: 4px;
}

.loading .dot {
    animation: blink 1.4s infinite;
}

.loading .dot:nth-child(1) {
    animation-delay: 0s;
}

.loading .dot:nth-child(2) {
    animation-delay: 0.2s;
}

.loading .dot:nth-child(3) {
    animation-delay: 0.4s;
}

.placeholder-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 20px 0;
    font-size: 16px;
    font-weight: 400;
}

.mb-2 {
    margin-bottom: 0.5rem;
}

@keyframes blink {
    0%,
    100% {
        opacity: 0.2;
    }

    50% {
        opacity: 1;
    }
}
</style>
